import { useEffect, useState } from 'react';
import { useSplitClient } from '@splitsoftware/splitio-react';

import {
    AP_FEATURE_FLAG,
    AP_LOCALSTORAGE_KEY,
    AP_MODULES_AND_PAGE_TREATMENT,
    AP_MODULES_TREATMENT,
    AP_PAGE_ONLY_TREATMENT,
    AP_PAGE_ORGANIC,
} from 'constants/featureFlags/assortmentPreview';
import { getAnonymousId } from 'utils/globalUtils';

const apLocalStorage = localStorage.getItem(AP_LOCALSTORAGE_KEY);

const inApLocalStorage =
    apLocalStorage === AP_MODULES_TREATMENT ||
    apLocalStorage === AP_MODULES_AND_PAGE_TREATMENT ||
    apLocalStorage === AP_PAGE_ORGANIC;

const inApPhaseTwoLocalStorage = apLocalStorage === AP_MODULES_AND_PAGE_TREATMENT || apLocalStorage === AP_PAGE_ORGANIC;

const inApPageOnlyLocalStorage = apLocalStorage === AP_PAGE_ONLY_TREATMENT;

export const useInAssortmentPreviewFlag = (active = true) => {
    const [inAssortmentPreview, setInAssortmentPreview] = useState(false);
    const [inAssortmentPreviewPhaseTwo, setInAssortmentPreviewPhaseTwo] = useState(false);

    const {
        client: splitClient,
        isReady: splitIsReady,
        isTimedout: splitTimedOut,
    } = useSplitClient({
        splitKey: active ? getAnonymousId() : undefined,
        updateOnSdkTimedout: true,
    });

    const treatment = active
        ? splitClient?.getTreatments([AP_FEATURE_FLAG], {
              brand: 'misfits-market',
          })[AP_FEATURE_FLAG]
        : 'off';
    const inAssortmentPreviewSplitTreatment =
        treatment === AP_MODULES_TREATMENT || treatment === AP_MODULES_AND_PAGE_TREATMENT;
    const inPageOnlyTreatment = treatment === AP_PAGE_ONLY_TREATMENT || inApPageOnlyLocalStorage;

    const splitLoadedCorrectly = splitIsReady && !splitTimedOut;

    useEffect(() => {
        const onSneakPeekPage = window.location.pathname === '/grocery-and-produce-delivery-sneak-peek';
        const organicCustomer = !inAssortmentPreviewSplitTreatment && onSneakPeekPage;

        if (inApLocalStorage) setInAssortmentPreview(true);

        if (inApPhaseTwoLocalStorage) setInAssortmentPreviewPhaseTwo(true);

        if (apLocalStorage === 'off' && onSneakPeekPage) {
            localStorage.setItem(AP_LOCALSTORAGE_KEY, AP_PAGE_ORGANIC);
        }

        if (!apLocalStorage) {
            const getVariant = () => {
                if (!onSneakPeekPage) return treatment;
                if (organicCustomer) return AP_PAGE_ORGANIC;
                if (inPageOnlyTreatment) return AP_PAGE_ONLY_TREATMENT;
                return AP_MODULES_AND_PAGE_TREATMENT;
            };

            localStorage.setItem(AP_LOCALSTORAGE_KEY, getVariant());

            setInAssortmentPreview(treatment !== 'off');

            setInAssortmentPreviewPhaseTwo(treatment === AP_MODULES_AND_PAGE_TREATMENT || onSneakPeekPage);
        }
    }, [splitLoadedCorrectly, treatment]);

    return {
        inAssortmentPreview,
        inAssortmentPreviewPhaseTwo,
        apLocalStorage,
        inPageOnlyTreatment,
        treatment,
        splitLoadedCorrectly,
    };
};
